export default __webpack_public_path__ + "static/bd-ca15666c40ddf69e13271ef4f18e74c2.svg";